/**
 * @fileoverview A function that renders the staff routes.
 *
 * @example
 * renderStaffRoutes()
 */

import { Route } from 'react-router-dom'
import { StaffCard } from '../components/admin/staff/StaffCard'
import { StaffList } from '../components/admin/StaffList'
import { Layout } from '../components/Layout'

/**
 * @function renderStaffRoutes
 * @description Renders the staff routes.
 * @returns {React.ReactNode} - The staff routes.
 */
export function renderStaffRoutes() {
    return (
        <Route path="staff" element={<Layout />}>
            <Route path=":userId/*" element={<StaffCard />}></Route>
            <Route index element={<StaffList />} />
        </Route>
    )
}
